<template>
	<div class="whatsapp-promo-card">
		<div v-if="closable" class="close-button" @click="$emit('close')">
			<img src="../../assets/close-24px.svg" alt="Close" />
		</div>

		<img v-if="showImage" src="../../assets/WhatsappPromo.png" alt="WhatsApp" class="promo-image" />

		<div class="card-title">{{ title }}</div>
		<div class="card-subtitle">{{ subtitle }}</div>

		<MGButton
			:text="buttonText"
			:icon="require('@/assets/whatsapp.png')"
			:leftIconSize="20"
			:arrow="true"
			:disabled="clicked"
			:fullWidth="true"
			:backgroundColor="'var(--whatsapp-green)'"
			@click="handleClick"
		/>

		<div v-if="clicked" class="sent-message">We've sent you a message, please check your WhatsApp messages.</div>
	</div>
</template>

<script>
import MGButton from './MGButton.vue';

export default {
	name: 'WhatsAppPromoCard',
	components: {
		MGButton
	},
	data() {
		return {
			clicked: false
		}
	},
	props: {
		title: {
			type: String,
			default: 'Send a document or photo'
		},
		subtitle: {
			type: String,
			default: "We'll add the key details and save the document securely. You can also chat with our WhatsApp assistant."
		},
		buttonText: {
			type: String,
			default: 'Add via WhatsApp'
		},
		showImage: {
			type: Boolean,
			default: false
		},
		closable: {
			type: Boolean,
			default: true
		}
	},
	emits: ['close', 'action'],
	methods: {
		handleClick() {
			if (!this.clicked) {
				this.$emit('action');
			}
		},
		setClicked() {
			this.clicked = true;
		},
		reset() {
			this.clicked = false;
		}
	}
}
</script>

<style scoped>
.whatsapp-promo-card {
	background: white;
	border-radius: 8px;
	padding: 20px;
	display: flex;
	flex-direction: column;
	gap: 8px;
	position: relative;
}

.close-button {
	position: absolute;
	top: 12px;
	right: 12px;
	width: 24px;
	height: 24px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}

.close-button img {
	width: 12px;
	height: 12px;
}

.promo-image {
	width: 100%;
	height: auto;
	border-radius: 8px;
	margin-bottom: 8px;
}

.card-title {
	font-size: 16px;
	font-weight: bold;
}

.card-subtitle {
	font-size: 13px;
	margin-bottom: -30px;
}

.sent-message {
	font-size: 13px;
	margin-top: 4px;
}

:deep(.leftIcon) {
	filter: brightness(0) invert(1);
}
</style>
